import { initialState } from 'state';
import { analytics, useUser } from 'libs';
import { Select } from 'components/common';
import Filter from './Filter';

interface RegionOption {
  label: string;
  value: string;
}

interface RegionFilterProps {
  filters: { regions?: string };
  isPro?: boolean;
  onFilter: (update: { regions: string | null }) => void;
}

const RegionFilter = ({ filters, isPro = false, onFilter }: RegionFilterProps) => {
  const { regions } = initialState;
  const user = useUser();
  const disabled = isPro && !user.features.is_pro;

  const onChange = (selected: RegionOption | null) => {
    const filter = { regions: selected?.value || null };

    analytics.productSearch.filter({
      provincial_availability: filter.regions || 'cleared',
    });
    onFilter(filter);
  };

  const getOptions = (): RegionOption[] => {
    return regions.map((region: { id: string; name: string }) => ({
      label: region.name,
      value: region.id,
    }));
  };

  const options = getOptions();

  return (
    <Filter name="Provincial Availability" isPro={isPro}>
      <Select
        className="form-react-select"
        clearValue={null}
        disabled={disabled}
        onChange={onChange}
        options={options}
        placeholder="All"
        selected={options.find((option) => option.value === filters.regions) || null}
        testId="filter-region"
      />
    </Filter>
  );
};

export default RegionFilter;
